<section class="suggested-text">
  <h3>
    {{ "brand.campaign.contentCalendarPost.suggestedText" | translate }}
    <app-tooltip
      *ngIf="platform !== PostTargetPlatforms.LinkedIn"
      text="{{
        'brand.campaign.contentCalendarPost.suggestedTextInfoCard' | translate
      }}"
    ></app-tooltip>
    <app-tooltip
      *ngIf="platform === PostTargetPlatforms.LinkedIn"
      text="{{
        'brand.campaign.contentCalendarPost.linkedInSuggestedTextInfoCard'
          | translate
      }}"
    ></app-tooltip>
  </h3>
  <div>
    <mat-form-field class="post-content">
      <mat-label>{{
        "brand.campaign.contentCalendarPost.typeContent" | translate
      }}</mat-label>
      <textarea
        matInput
        [formControl]="formControl"
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
        id="post-content"
        name="post-content"
        type="text"
        tabindex="-1"
        style="overflow: hidden"
        (input)="reflectTextChanges()"
      >
      </textarea>
      <mat-hint *ngIf="formControl && maxLength" align="end">
        {{ formControl.value.length }} / {{ maxLength }}
      </mat-hint>
      @if (formControl.hasError("required")) {
        <mat-error>
          {{
            "brand.campaign.contentCalendarPost.typeContentRequired" | translate
          }}
        </mat-error>
      }
      @if (formControl.hasError("unrecognizedTag")) {
        <mat-error>
          {{ "brand.campaign.contentCalendarPost.wrongTag" | translate }}
        </mat-error>
      }
      @if (formControl.hasError("maxlength")) {
        <mat-error align="end">
          {{ formControl.value.length }} / {{ maxLength }}
        </mat-error>
      }
    </mat-form-field>
    <mat-hint *ngIf="formControl.value"
      ><b>{{ "brand.campaign.contentCalendarPost.hintTitle" | translate }}</b>
      <br />{{
        "brand.campaign.contentCalendarPost.hintDescription" | translate
      }}</mat-hint
    >
  </div>

  <div *ngIf="formControl.value && postTags?.length > 0" class="grid-hints">
    <button
      *ngFor="let tag of postTags"
      [ngClass]="{
        hide:
          tag.tag === UNIQUE_CAMPAIGN_URL_TAG &&
          type === CampaignType.DownloadOnly
      }"
      (click)="addPostTextTag(tag.tag)"
    >
      {{ "brand.campaign.contentCalendarPost." + tag.key | translate }}
    </button>
  </div>
  <ng-container
    *ngIf="
      formControl.value &&
      !disableCampaignUniqueUrlWarning &&
      !checkContainsUniqueCampaignUrl()
    "
  >
    <mat-label
      *ngIf="platformsSelected?.instagram && platformsSelected?.facebook"
      class="warning"
      >{{
        "brand.campaign.contentCalendarPost.selectingFacebookAndInstagramWarning"
          | translate
      }}</mat-label
    >
    <mat-label
      class="warning"
      *ngIf="!platformsSelected?.instagram && platformsSelected?.facebook"
    >
      {{
        "brand.campaign.contentCalendarPost.uniqueCampaignUrlWarning"
          | translate
      }}</mat-label
    ></ng-container
  >
</section>
